// extracted by mini-css-extract-plugin
export default {"imageWrapper":"gM-z","twoColumnImage":"hM-z"};